import { BannerModule, SpacingModule } from '@frk/eds-components';

import { BrSdkModule } from '@bloomreach/ng-sdk';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { BannerMultiPromoComponent } from './banner-multi-promo.component';

@NgModule({
  declarations: [BannerMultiPromoComponent],
  imports: [BrSdkModule, BannerModule, CommonModule, SpacingModule],
  exports: [BannerMultiPromoComponent],
  entryComponents: [BannerMultiPromoComponent],
})

/**
 * Link List Module
 */
export class BannerMultiPromoModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Banner Multi Promo': BannerMultiPromoComponent,
    };
  }
}
